import { ReactElement } from 'react';
import { PermissionDTO } from '../PermissionDTO';
import { PermissionScreen } from '../PermissionScreen';
import { usePermissionAccess } from '../data/usePermissionAccess';

export function PermissionView<T extends keyof PermissionDTO>({
  children,
  name,
  permission,
}: {
  children: ReactElement;
  name: T;
  permission: keyof NonNullable<PermissionDTO[T]>;
}) {
  const hasAccess = usePermissionAccess({ name, permission });

  if (!hasAccess) {
    return children;
  }

  return <PermissionScreen />;
}
